const Message = {
    CREATED_MESSAGE: "38583B60-49CA-11EB-8645-8FE6D6DD0832",
    UPDATED_MESSAGE: "C445AAD0-444E-11EB-8645-8FE6D6DD0832",
    DELETE_MESSAGE: "43E31D20-5559-11EB-8645-8FE6D6DD0832",
    MANDATORY_FIELDS: "0624CFF0-A7E4-11EB-B6A9-4D5F7125E72D",
    TRANSLATION_COMPLTE: "1D8DE040-A33A-11EB-B9F5-D3EEBAF33A87",
    CREATE_IN_ALL_LANGUAGE: "FCEF49D0-176C-11EC-91BB-113BA94187DF",
    AGENCY_DELETE_FINANCIAL_PERIOD_REFERENCE: "0D9D3850-4FAC-11ED-B575-C99D12EF6BD8",
    ACTIVATED_MESSAGE: "D81A9FD0-58D3-11EC-90FD-BD1FD651A36A",
    DEACTIVATED_MESSAGE: "0565EE40-58D4-11EC-90FD-BD1FD651A36A",
    DELETE_CONFIRMATION_MESSAGE: "83E90740-4EA9-11ED-9721-A502960E061B",
    ACTIVATE_CONFIRMATION_MESSAGE: "C9A766C0-691E-11ED-8ED7-11AAF2E46724",
    DEACTIVATE_CONFIRMATION_MESSAGE: "E57AD080-691E-11ED-8ED7-11AAF2E46724",
    PLEASE_SELECT_LANGUAGE: "F1A8AD80-6E61-11ED-B43E-293D24D86484",
}


export {
    Message
}